export default "__VITE_ASSET__Bl5I5ZMp__"